import RepositoryFactory from "@/marcom/Apicall/RepositoryFactory";
// const smsCampaign = RepositoryFactory.smsCampaign;

export default {
  getAllUsers({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.manageUser.GetAllUsers(
          payload
        );

        // commit("GET_ALL_USER_DETAILS", { key: "users", value: data.data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  updateUser({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await RepositoryFactory.manageUser.updateUser(payload);

        // commit("GET_ALL_USER_DETAILS", { key: "users", value: data.data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  createSegmentType({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await RepositoryFactory.manageUser.createSegmentTypes(
          payload
        );

        commit("SET_SEGMENT_TYPE_DETAILS", {
          key: "segmentType",
          value: data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  createSegment({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await RepositoryFactory.manageUser.createSegment(payload);

        commit("SET_SEGMENT_DETAILS", { key: "segment", value: data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getAllSegmentTypes({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await RepositoryFactory.manageUser.getAllSegmentType(
          payload
        );

        commit("GET_ALL_SEGMENT_TYPES", {
          key: "types",
          value: data.data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  getAllSegments({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await RepositoryFactory.manageUser.getAllSegment(payload);

        commit("GET_ALL_SEGMENT", {
          key: "getSegments",
          value: data.data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  addNewEntity({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await RepositoryFactory.manageUser.addAudience(payload);

        commit("ADD_NEW_ENTITY", { key: "newEntity", value: data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  deleteAudience({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await RepositoryFactory.manageUser.deleteAudience(payload);

        commit("DELETE_AUDIENCE", { key: "deleteAudience", value: data.data });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },

  updateAudience({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const data = await RepositoryFactory.manageUser.updateAudience(payload);

        commit("UPDATE_AUDIENCE", {
          key: "updateOneAudience",
          value: data.data,
        });

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
